<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Prove It All Night</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#intro">Intro</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-one-the-motors">Chapter One The Motors</a><ol class="toc"><li id="toc-li-6"><a href="#/text/ch005#north-staffs-poly-stafford-september-1977"></a></li>
</ol></li>
<li id="toc-li-7"><a href="#/text/ch006#chapter-two-the-clash">Chapter Two The Clash</a><ol class="toc"><li id="toc-li-8"><a href="#/text/ch006#victoria-park-hackney-london-april-1978"></a></li>
</ol></li>
<li id="toc-li-9"><span href="#/text/ch007#chapter-three-bob-marley-and-the-wailers" title="Link target outside of Sample">Chapter Three Bob Marley and the Wailers</span><ol class="toc"><li id="toc-li-10"><span href="#/text/ch007#bingley-hall-stafford-june-1978" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-11"><span href="#/text/ch008#chapter-four-david-bowie" title="Link target outside of Sample">Chapter Four David Bowie</span><ol class="toc"><li id="toc-li-12"><span href="#/text/ch008#bingley-hall-stafford-june-1978-1" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-13"><span href="#/text/ch009#chapter-five-doctor-feelgood" title="Link target outside of Sample">Chapter Five Doctor Feelgood</span><ol class="toc"><li id="toc-li-14"><span href="#/text/ch009#birmingham-odeon-october-1978" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-15"><span href="#/text/ch010#chapter-six-the-jam" title="Link target outside of Sample">Chapter Six The Jam</span><ol class="toc"><li id="toc-li-16"><span href="#/text/ch010#birmingham-odeon-november-1978" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-17"><span href="#/text/ch011#chapter-seven-alberto-y-lost-trios-paranoias-and-the-police" title="Link target outside of Sample">Chapter Seven Alberto Y Lost Trios Paranoias and The Police</span><ol class="toc"><li id="toc-li-18"><span href="#/text/ch011#north-staffs-polytechnic-stoke-december-1978" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-19"><span href="#/text/ch012#chapter-eight-the-who" title="Link target outside of Sample">Chapter Eight The Who</span><ol class="toc"><li id="toc-li-20"><span href="#/text/ch012#bingley-hall-stafford-november-1979" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-21"><span href="#/text/ch013#chapter-nine-bruce-springsteen-and-the-e-street-band" title="Link target outside of Sample">Chapter Nine Bruce Springsteen and the E Street Band</span><ol class="toc"><li id="toc-li-22"><span href="#/text/ch013#bingley-hall-stafford-may-1981" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-23"><span href="#/text/ch014#chapter-ten-the-rolling-stones" title="Link target outside of Sample">Chapter Ten The Rolling Stones</span><ol class="toc"><li id="toc-li-24"><span href="#/text/ch014#wembley-stadium-london-june-1982" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-25"><span href="#/text/ch015#encore" title="Link target outside of Sample">Encore</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?cf809eb8